<template>
	<div>
		<div class="position-relative">
			<!-- shape Hero -->
			<section class="section-shaped">
				<div class="shape shape-style-1 shape-dark shape-skew">
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div>
				<div class="container shape-container d-flex">
					<div class="col px-0">
						<div class="row justify-content-between">
							<div class="col-lg-12">
								<h1 class="display-3 text-white">
									Контакты
									<span class="text-danger">Алкоголь стал проблемой? Выход есть!</span>
								</h1>
								<p class="lead text-white" style="font-weight: 500; ">
									Позвоните нам <a href="tel:+421949763805">+421949763805</a> или отправьте сообщение в
									<a href="https://wa.me/421949763805" target="_blank">WhatsApp</a>
								</p>
								<h4 class="text-info my-1">
									Все контакты с нами полностью анонимны
								</h4>
								<hr style="border-color:gray" class=" my-5" />
							</div>
							<div class="col-lg-12">
								<h3 class="text-white">Адрес живых встреч</h3>
								<p class="text-white" style="font-size: 1.3rem;">
									YMCA, 2й этаж (лестница), комната 270 (на двери вывеска АА)<br />
									Karpatská 2, Bratislava, Slovakia 81105
								</p>
								<iframe
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2661.5768931130847!2d17.111552016031787!3d48.15696175778905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476c89523f91a64d%3A0x2ce8fa5a399fab31!2sYMCA!5e0!3m2!1sen!2ssk!4v1665518907541!5m2!1sen!2ssk"
									width="100%"
									height="450"
									style="border:0;"
									allowfullscreen=""
									loading="lazy"
									referrerpolicy="no-referrer-when-downgrade"
								></iframe>
								<img src="/img/ymca.jpg" class="w-100" />
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- 1st Hero Variation -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'contact',
	components: {},
};
</script>

<style></style>
